import TextBlock from '../components/textBlock'

class TextBlocks {
    components: TextBlock[] = []

    init(container: Document | HTMLElement = document) {
        container.querySelectorAll<HTMLElement>('.hg-text-block').forEach((el) => {
            const component = new TextBlock(el)
            component.init()
            this.components.push(component)
        })
    }

    update(container: Document | HTMLElement = document) {
        this.cleanup()
        this.init(container)
    }

    cleanup() {
        this.components.forEach((component) => component.cleanup())
        this.components = []
    }
}

export default new TextBlocks()
